import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { IFilterParams } from 'ag-grid-community';
import { Country } from 'src/app/shared/models/country.model';
import { FiltersService } from 'src/app/shared/services/filters.service';
import { GridService } from 'src/app/shared/services/grid-defs.service';
import { FiltersCheckboxService } from '../../services/filters-checkbox.service';

@Component({
  selector: 'app-checkbox-filter-certificate',
  templateUrl: './checkbox-filter-certificate.component.html',
  styleUrls: ['./checkbox-filter-certificate.component.scss']
})
export class CheckboxFilterCertificateComponent implements OnInit {
  form: FormGroup;
  countries: Country[];
  filter = '';
  disabled = true;
  params: IFilterParams;
  currentColumn: string;
  selectedFilter;



  constructor(
    private formBuilder: FormBuilder,
    public filtersService: FiltersService,
    public gridService: GridService,
    public filtersCheckboxService:FiltersCheckboxService
  ) {
    this.form = this.formBuilder.group({
      orders: new FormArray([
      ])
    });
  }

  ngOnInit() {}

  private addCheckboxes() {
    this.filtersCheckboxService.filterGroup.certificates = this.filtersService.certificatesFilters;
    this.filtersCheckboxService.filterGroup.users = this.filtersService.usersFilters;
    this.selectedFilter = this.filtersCheckboxService.filterGroup[this.gridService.currentDef][
      this.currentColumn
    ];
    let option = 0;
    let array: any[] = [];
    array = this.filtersCheckboxService.getCheckBoxesFiltersByCountryLocalStorage();
    if (array.length > 0) {
      option = 0;
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        let control;
        if (element == 'true') {
          control = new FormControl(true);
        } else {
          control = new FormControl(false);
        }

        (this.form.controls.orders as FormArray).push(control);
      }
    } else {
      this.selectedFilter.forEach(filter => {
        const control = new FormControl(true);
        (this.form.controls.orders as FormArray).push(control);
      });
    }
    this.params.context.componentParent.onOpen('open');

  }

  get arrayOfOrders() {
    return (this.form.get('orders') as FormArray).controls;
  }

  agInit(params: IFilterParams): void {
    this.currentColumn = params.colDef.field;
    this.params = params;
    localStorage.setItem(params.colDef.field, params.colDef.field);

    this.addCheckboxes();
  }

  isFilterActive() {
    return this.disabled !== false;
  }

  getValue(value) {
    if (typeof value === 'string') {
      return value;
    } else {
      return value.code;
    }
  }

  doesFilterPass(params) {
    const value = this.getValue(params.data[this.currentColumn]);
    const valueOfControlers = this.form.get('orders').value;
    const checkedFilters = valueOfControlers.map((inputWord, i) => {
      if (inputWord) {
        if (this.currentColumn === 'role') {
          return this.selectedFilter[i].shortName;
        }
        return this.selectedFilter[i].code;
      }
    });
    console.log('value', value);
    console.log('valueOfControlers', valueOfControlers);
    console.log('checked', checkedFilters);
    // console.log(this.params.context.componentParent.form)
    // console.log(this.form)
    // this.setFilterCheckboxByGridLocalStorage();
    // this.filtersCheckboxService.setCheckBoxesFiltersACRByCountryLocalStorage(
    //   checkedFilters
    // );

    return checkedFilters.includes(value);
  }

  getModel() {
    return { filter: this.filter };
  }

  setModel(model) {
    this.filter = model ? model.filter : '';
  }

  executeCallback(index: number, params, event) {
    const items = this.form.get('orders') as FormArray;
    const selectedItem = items.value;

    if (this.currentColumn === 'status') {
      const isLast = index === this.filtersCheckboxService.filterGroup[this.gridService.currentDef].status.length - 1;
      if (isLast) {
        const elemnt = selectedItem[index];
        if (elemnt) {
          for (let index = 0; index < items.length; index++) {
            items.controls[index].patchValue({ [index]: true });
          }
        } else {
          for (let index = 0; index < items.length - 1; index++) {
            items.controls[index].setValue(false);
          }
        }
      }
    }
    this.params.filterChangedCallback();
  }

  //
  setFilterCheckboxByGridLocalStorage() {
    let array: any[] = [];
    console.log('orders', this.form.controls.orders);
    console.log('form', this.form);
    (this.form.controls.orders as FormArray).controls.forEach(
      (element, index) => {
        array.push(element.value);
      }
    );
    this.filtersCheckboxService.setCheckBoxesFiltersByCountryLocalStorage(
      array
    );
  }
}
